// extracted by mini-css-extract-plugin
export default {"root":"Settings_root__Sf6yd","boxRoot":"Settings_boxRoot__vVbjc"};